import { FieldFormatType } from '../../types/form/field-format-type';
import { dateFormatValidationRule } from './validation-rules/date-format-validation-rule';
import { emailFormatValidationRule } from './validation-rules/email-format-validation-rule';
import { getMinAgeValidationRule } from './validation-rules/min-age-validation-rule';
import { decimalValidationRule, getNumberRangeValidationRule, integerValidationRule } from './validation-rules/number-validation-rule';
import { numericOnlyValidationRule } from './validation-rules/numeric-only-validation-rule';
import { getPasswordValidationRule } from './validation-rules/password-validation-rule';
import { getRegexFormatValidationRule } from './validation-rules/regex-format-validation-rule';
import { requiredValidationRule } from './validation-rules/required-validation-rule';
import { getStringLengthValidationRule } from './validation-rules/string-length-validation-rule';
export const getFieldValidatorForConfig = (config) => {
    const rules = [];
    if (config.required)
        rules.push(requiredValidationRule);
    switch (config.type) {
        case FieldFormatType.Text: {
            if (config.minLength || config.maxLength) {
                rules.push(getStringLengthValidationRule(config.minLength, config.maxLength));
            }
            if (config.format)
                rules.push(getRegexFormatValidationRule(config.format));
            break;
        }
        case FieldFormatType.Email: {
            rules.push(emailFormatValidationRule);
            break;
        }
        case FieldFormatType.Number: {
            if (config.minLength || config.maxLength) {
                rules.push(getStringLengthValidationRule(config.minLength, config.maxLength));
            }
            rules.push(numericOnlyValidationRule);
            break;
        }
        case FieldFormatType.Decimal: {
            rules.push(decimalValidationRule);
            if (config.range) {
                rules.push(getNumberRangeValidationRule(config.range));
            }
            break;
        }
        case FieldFormatType.Integer: {
            rules.push(integerValidationRule);
            if (config.range) {
                rules.push(getNumberRangeValidationRule(config.range));
            }
            break;
        }
        case FieldFormatType.Date: {
            rules.push(dateFormatValidationRule);
            if (config.minAge)
                rules.push(getMinAgeValidationRule(config.minAge));
            break;
        }
        case FieldFormatType.Password: {
            const passwordRules = config.rules.map(getPasswordValidationRule);
            rules.push(...passwordRules);
            break;
        }
        default:
            break;
    }
    // Do any custom validation last.
    if (config.customValidation)
        rules.push(config.customValidation);
    return async (data) => {
        if (!config.required && data === '')
            return undefined;
        for (const rule of rules) {
            const result = await rule(data);
            if (result !== undefined)
                return result;
        }
        return undefined;
    };
};
//# sourceMappingURL=get-field-validator-for-config.js.map